import styled, { css } from "styled-components";

import { fontStyle } from "@pages/casino/assets/styles/mixins";

import { getTenantCardSizes } from "./utils.js";

const changeCardHeightByTenant = () => {
	const tenant = window.TENANT;

	switch (tenant) {
		case "etoro":
			return "140px";
		case "mars":
			return "155px";
		default:
			return "140px";
	}
};

export const CardWrapper = styled.div`
	:root {
		--color1: rgb(198 198 198 / 59%);
		--color2: rgb(198 198 198 / 59%);
	}

	position: relative;

	#game-image-wrapper .img-container .sparkle {
		display: none;
	}

	${({ hasNoShadow }) =>
		hasNoShadow &&
		css`
			#game-image-wrapper {
				.img-container {
					&::after {
						box-shadow: unset !important;
						filter: unset !important;
					}
				}
			}
		`}

	#game-image-wrapper {
		.img-container {
			&::after {
				content: "";
				display: block;
				height: 100%;
				position: absolute;
				top: 0;
				width: 100%;
				border-radius: 15px;
				box-shadow: inset 0 0 7px 3px #1d0637d4;
				mix-blend-mode: multiply;
				filter: drop-shadow(10px 10px 10px rgba(29, 10, 55, 1));
				border-radius: 15px;

				${window.CASINO_GAME_CARD_V2 &&
				css`
					box-shadow:
						0px 2.8px 2.8px 0px rgba(0, 0, 0, 0.25),
						0px 0px 14px 0px rgba(0, 0, 0, 0.25) inset;
				`}
			}
		}
	}

	:hover,
	:focus {
		#play-overlay {
			display: flex;
			top: 0;
			border-radius: 15px;
			padding: 0 8px;

			&::after {
				content: "";
				display: block;
				height: 100%;
				position: absolute;
				top: 0;
				width: 100%;
				box-shadow: var(--casino-game-hover-inset);
				filter: drop-shadow(10px 10px 10px rgba(29, 10, 55, 1));
				border-radius: 15px;
			}
		}
		@media (min-width: 1024px) {
			#game-image-wrapper > .img-container > img {
				${() =>
					window.CASINO_GAME_HOVER_RESIZE &&
					css`
						transform: scale(115%);
						transition: ease-in-out 0.3s;
					`}
			}
		}

		#game-image-wrapper > .img-container > .sparkle {
			position: absolute;
			display: block;
			z-index: 1;

			:nth-child(2) {
				top: 0;
				left: 0;
				width: 100%;
				height: 2px;
				background: linear-gradient(90deg, transparent, var(--main-color-light));
				animation: animate1 1s linear infinite;
			}

			:nth-child(3) {
				top: -100%;
				right: 0;
				width: 2px;
				height: 100%;
				background: linear-gradient(180deg, transparent, var(--main-color-light));
				animation: animate2 1s linear infinite;
				animation-delay: 0.25s;
			}

			:nth-child(4) {
				bottom: 0;
				right: 0;
				width: 100%;
				height: 2px;
				background: linear-gradient(270deg, transparent, var(--main-color-light));
				animation: animate3 1s linear infinite;
				animation-delay: 0.5s;
			}

			:nth-child(5) {
				bottom: -100%;
				left: 0;
				width: 2px;
				height: 100%;
				background: linear-gradient(360deg, transparent, var(--main-color-light));
				animation: animate4 1s linear infinite;
				animation-delay: 0.75s;
			}
		}

		@keyframes animate1 {
			0% {
				left: -100%;
			}
			50%,
			100% {
				left: 100%;
			}
		}

		@keyframes animate2 {
			0% {
				top: -100%;
			}
			50%,
			100% {
				top: 100%;
			}
		}

		@keyframes animate3 {
			0% {
				right: -100%;
			}
			50%,
			100% {
				right: 100%;
			}
		}

		@keyframes animate4 {
			0% {
				bottom: -100%;
			}
			50%,
			100% {
				bottom: 100%;
			}
		}
	}

	${({ hasPlayIconAndGameName }) =>
		hasPlayIconAndGameName &&
		css`
			:hover,
			:focus {
				#play-overlay {
					&::after {
						border: 1px solid var(--main-color);
						background: var(--casino-game-card-bg);
						filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
						box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset;
						backdrop-filter: blur(5px);
					}
				}
			}
		`}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.img-container {
		position: relative;
		border-radius: 15px;
		margin-bottom: ${() => (window.CASINO_GAME_CARD_V2 ? "5px" : "10px")};
		overflow: hidden;
		width: 100%;

		img {
			width: 136px;
			height: 106px;
			border-radius: 15px;
			box-shadow:
				0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset,
				0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
			@media (min-width: 425px) {
				width: 170px;
				height: ${changeCardHeightByTenant()};
			}
		}

		img[data-size="1x1"] {
			width: ${getTenantCardSizes()["1x1"].width};
			height: ${getTenantCardSizes()["1x1"].height};

			@media (min-width: 1600px) {
				width: ${getTenantCardSizes()["1x1"].wideDesktopWidth};
				height: ${getTenantCardSizes()["1x1"].wideDesktopHeight};
			}
		}

		img[data-size="4x5"] {
			width: ${getTenantCardSizes()["4x5"].width};
			height: ${getTenantCardSizes()["4x5"].height};

			@media (min-width: 1600px) {
				width: ${getTenantCardSizes()["4x5"].wideDesktopWidth};
				height: ${getTenantCardSizes()["4x5"].wideDesktopHeight};
			}
		}

		img[data-size="1x2"] {
			width: ${getTenantCardSizes()["1x2"].width};
			height: ${getTenantCardSizes()["1x2"].height};

			@media (min-width: 1600px) {
				width: ${getTenantCardSizes()["1x2"].wideDesktopWidth};
				height: ${getTenantCardSizes()["1x2"].wideDesktopHeight};
			}
		}

		img[data-size="2x2"] {
			width: ${getTenantCardSizes()["2x2"].width};
			height: ${getTenantCardSizes()["2x2"].height};

			@media (min-width: 1600px) {
				width: ${getTenantCardSizes()["2x2"].wideDesktopWidth};
				height: ${getTenantCardSizes()["2x2"].wideDesktopHeight};
			}
		}

		img[data-size="2x1"] {
			width: ${getTenantCardSizes()["2x1"].width};
			height: ${getTenantCardSizes()["2x1"].height};

			@media (min-width: 1600px) {
				width: ${getTenantCardSizes()["2x1"].wideDesktopWidth};
				height: ${getTenantCardSizes()["2x1"].wideDesktopHeight};
			}
		}
	}
`;

export const GameAffiliateName = styled.span`
	text-transform: uppercase;
	height: 24px;
	color: var(--secondary-text-color);
	${fontStyle}
	font-size: 10px;
	font-weight: 400;
	position: relative;
	z-index: 2;
	@media (min-width: 425px) {
		font-size: 12px;
	}
	@media (min-width: 768px) {
		font-weight: 400;
	}

	${() =>
		window.CASINO_GAME_CARD_V2 &&
		css`
			font-size: 9px;
			font-style: normal;
			font-weight: 400;
			line-height: 16px;
			letter-spacing: 0.175px;
			height: 20px;
			@media (min-width: 425px) {
				font-size: 9px;
			}
		`}
`;

export const OverlayContainer = styled.div`
	#play-overlay[data-size="1x1"] {
		width: ${getTenantCardSizes()["1x1"].overlayWidth};
		height: ${getTenantCardSizes()["1x1"].overlayHeight};

		@media (min-width: 1600px) {
			width: ${getTenantCardSizes()["1x1"].overlayWideDesktopWidth};
			height: ${getTenantCardSizes()["1x1"].overlayWideDesktopHeight};
		}
	}

	#play-overlay[data-size="4x5"] {
		width: ${getTenantCardSizes()["4x5"].overlayWidth};
		height: ${getTenantCardSizes()["4x5"].overlayHeight};

		@media (min-width: 1600px) {
			width: ${getTenantCardSizes()["4x5"].overlayWideDesktopWidth};
			height: ${getTenantCardSizes()["4x5"].overlayWideDesktopHeight};
		}
	}

	#play-overlay[data-size="1x2"] {
		width: ${getTenantCardSizes()["1x2"].overlayWidth};
		height: ${getTenantCardSizes()["1x2"].overlayHeight};

		@media (min-width: 1600px) {
			width: ${getTenantCardSizes()["1x2"].overlayWideDesktopWidth};
			height: ${getTenantCardSizes()["1x2"].overlayWideDesktopHeight};
		}
	}

	#play-overlay[data-size="2x2"] {
		width: ${getTenantCardSizes()["2x2"].overlayWidth};
		height: ${getTenantCardSizes()["2x2"].overlayHeight};

		@media (min-width: 1600px) {
			width: ${getTenantCardSizes()["2x2"].overlayWideDesktopWidth};
			height: ${getTenantCardSizes()["2x2"].overlayWideDesktopHeight};
		}
	}

	#play-overlay[data-size="2x1"] {
		width: ${getTenantCardSizes()["2x1"].overlayWidth};
		height: ${getTenantCardSizes()["2x1"].overlayHeight};

		@media (min-width: 1600px) {
			width: ${getTenantCardSizes()["2x1"].overlayWideDesktopWidth};
			height: ${getTenantCardSizes()["2x1"].overlayWideDesktopHeight};
		}
	}
`;

export const PlayOverlay = styled.div`
	display: none;
	border-radius: 15px;
	margin-bottom: 10px;
	box-shadow:
		0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset,
		0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: var(--gray-white, #fff);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 136px;
	height: 106px;
	cursor: pointer;
	border-radius: 15px;

	${({ hasColorfulShadow }) =>
		hasColorfulShadow &&
		css`
			background: var(--casino-last-played-container-bg);
			border: 1px solid var(--main-color);
		`}

	@media (min-width: 425px) {
		width: 170px;
		height: ${changeCardHeightByTenant()};
	}

	p {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 50px;
		margin-top: 12px;
		font-weight: 600;
		letter-spacing: 0.3px;
		font-size: 10px;
		line-height: 10px;

		@media (min-width: 425px) {
			margin-bottom: 12px;
			margin-top: 12px;
			font-size: 12px;
			font-weight: 600;
			line-height: 28px;
			letter-spacing: 0.3px;
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 70px;
		}

		svg {
			margin-right: 5px;
			height: 10px;

			@media (min-width: 425px) {
				height: 12px;
			}

			@media (min-width: 1024px) {
				height: 14px;
			}
		}

		@media (min-width: 1600px) {
			margin-bottom: 70px;
		}

		@media (min-width: 1024px) {
			font-size: 14px;
		}
	}

	&[data-size="1x1"],
	&[data-size="4x5"] {
		p {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 50px;
			font-size: 10px;

			@media (min-width: 1024px) {
				font-size: 10px;
			}
			@media (min-width: 1280px) {
				font-size: 12px;
			}
			@media (min-width: 1600px) {
				font-size: 14px;
			}

			svg {
				margin-right: 5px;
				height: 10px;

				@media (min-width: 1024px) {
					height: 14px;
				}
			}

			@media (min-width: 1600px) {
				margin-bottom: 70px;
			}
		}
	}

	&[data-size="1x2"] {
		p {
			align-items: center;
			display: flex;
			flex-direction: column;
			gap: 5px;

			@media (min-width: 1024px) {
				font-size: 10px;
			}
			@media (min-width: 1280px) {
				font-size: 12px;
			}
			@media (min-width: 1600px) {
				font-size: 14px;
			}

			svg {
				@media (min-width: 1024px) {
					height: 14px;
				}
			}
		}
	}

	&[data-size="2x2"] {
		p {
			align-items: center;
			display: flex;
			flex-direction: column;
			gap: 5px;

			@media (min-width: 1024px) {
				font-size: 10px;
			}
			@media (min-width: 1280px) {
				font-size: 12px;
			}
			@media (min-width: 1600px) {
				font-size: 14px;
			}

			svg {
				@media (min-width: 1024px) {
					height: 14px;
				}
			}
		}
	}

	&[data-size="2x1"] {
		p {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 50px;

			@media (min-width: 1024px) {
				font-size: 10px;
			}
			@media (min-width: 1280px) {
				font-size: 12px;
			}
			@media (min-width: 1600px) {
				font-size: 14px;
			}

			@media (min-width: 1600px) {
				margin-bottom: 70px;
			}

			svg {
				margin-right: 5px;

				@media (min-width: 1024px) {
					height: 14px;
				}
			}
		}
	}
	${({ hasColorfulShadow }) =>
		hasColorfulShadow &&
		css`
			${PlayIconGameNameWrapper} {
				padding-bottom: 40px;
				justify-content: center;
			}
		`}
`;

export const GameName = styled.span`
	&[data-size="2x1"],
	&[data-size="1x2"],
	&[data-size="2x2"] {
		font-weight: 600;
		font-size: 16px;
		line-height: 16px;
		letter-spacing: 0.54px;
		text-transform: uppercase;
		text-align: center;

		${() =>
			window.CASINO_GAME_CARD_V2 &&
			css`
				font-size: 12px;
			`}
	}
	&[data-size="1x1"],
	&[data-size="4x5"] {
		font-size: 12px;
		font-weight: 600;
		line-height: 12px;
		letter-spacing: 0.54px;
		text-transform: uppercase;
		text-align: center;

		@media (min-width: 1600px) {
			font-size: 16px;
			line-height: 16px;
		}

		${() =>
			window.CASINO_GAME_CARD_V2 &&
			css`
				font-size: 12px;

				@media (min-width: 1600px) {
					font-size: 12px;
				}
			`}
	}

	display: flex;
	align-items: center;
	position: absolute;
	top: 50px;
	height: 50px;
	min-height: 50px;
	padding: 0px 8px;

	letter-spacing: 0.54px;
	text-transform: uppercase;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 12px;

	@media (min-width: 425px) {
		top: 65px;
		height: 60px;
		min-height: 60px;
		display: flex;
		align-items: center;
		position: absolute;
		font-size: 22px;
		line-height: 18px;
		letter-spacing: 0.3px;
		font-variant-caps: all-petite-caps;

		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="2x1"],
		&[data-size="1x2"],
		&[data-size="2x2"] {
			font-size: 16px;
			font-weight: 600;
			line-height: 16px;
			letter-spacing: 0.54px;
			text-transform: uppercase;
		}
	}

	${({ hasPlayIconAndGameName }) =>
		hasPlayIconAndGameName &&
		css`
			@media (min-width: 425px) {
				top: 70px;
			}
		`}

	@media (min-width: 1024px) {
		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="2x1"],
		&[data-size="1x2"],
		&[data-size="2x2"] {
			font-size: 18px;
			line-height: 14px;
			letter-spacing: 0.3px;
			font-size: 18px;
			font-weight: 600;
			font-variant-caps: all-petite-caps;
			line-height: 14px;
			letter-spacing: 0.3px;
		}
	}

	@media (min-width: 1280px) {
		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="2x1"],
		&[data-size="1x2"],
		&[data-size="2x2"] {
			font-size: 22px;
			font-weight: 600;
			font-variant-caps: all-petite-caps;
			line-height: 18px;
		}

		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="2x1"] {
			font-size: 18px;
			line-height: 14px;
			letter-spacing: 0.3px;
		}
	}
	@media (min-width: 1600px) {
		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="1x2"],
		&[data-size="2x2"],
		&[data-size="2x1"] {
			font-size: 26px;
			font-weight: 600;
			font-variant-caps: all-petite-caps;
			line-height: 22px;
		}

		&[data-size="1x1"],
		&[data-size="4x5"],
		&[data-size="2x1"] {
			font-size: 22px;
			line-height: 18px;
			letter-spacing: 0.3px;
		}
	}

	&[data-size="1x1"],
	&[data-size="4x5"] {
		position: absolute;
		top: 50px;
		display: flex;
		align-items: center;
		position: absolute;
		top: 50px;
		height: 50px;
		min-height: 50px;
		padding: 0 8px;

		@media (min-width: 1600px) {
			top: 65px;
			height: 60px;
			min-height: 60px;
		}
	}

	&[data-size="1x2"] {
		position: absolute;
		top: 160px;
		padding: 0 8px;
		display: flex;
		align-items: center;
		height: 70px;
		min-height: 70px;

		@media (min-width: 1600px) {
			top: 210px;
			height: 85px;
			min-height: 85px;
		}
	}

	&[data-size="2x2"] {
		position: absolute;
		top: 160px;
		padding: 0 8px;
		display: flex;
		align-items: center;
		height: 70px;
		min-height: 70px;

		@media (min-width: 1600px) {
			top: 210px;
			height: 85px;
			min-height: 85px;
		}
	}

	&[data-size="2x1"] {
		display: flex;
		align-items: center;
		position: absolute;
		top: 50px;
		height: 50px;
		min-height: 50px;
		padding: 0 8px;

		@media (min-width: 1600px) {
			top: 65px;
			height: 60px;
			min-height: 60px;
		}
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const PlayIconGameNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 20px 10px 10px 10px;
	width: 100%;
	height: 100%;
	z-index: 1;

	${({ hasPlayIconAndGameName }) =>
		hasPlayIconAndGameName &&
		css`
			justify-content: unset;
			padding: 13px 10px 10px 10px;

			img {
				bottom: 5px;
				position: relative;
			}
		`}

	span {
		text-align: center;
	}
`;
